import { render, staticRenderFns } from "./payment-transfer-form.vue?vue&type=template&id=c85d0f96"
import script from "./payment-transfer-form.vue?vue&type=script&lang=js"
export * from "./payment-transfer-form.vue?vue&type=script&lang=js"
import style0 from "./payment-transfer-form.vue?vue&type=style&index=0&id=c85d0f96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports